import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './Cabecalho.css'
import { ReactComponent as Logo } from '../assets/13471_Logo_Completa_preto.svg' // Importa o SVG
import { Link } from 'react-router-dom'

const Cabecalho = () => {
  const [username, setUsername] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    // Simulação: Recupera o nome do usuário do localStorage ou de uma API
    const user = localStorage.getItem('name') || 'Basalto'
    setUsername(user)
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('token') // Remove o token de autenticação
    localStorage.removeItem('username') // Remove o nome do usuário
    navigate('/login') // Redireciona para a tela de login
  }

  return (
    <header className='cabecalho-header'>
      <div className='cabecalho-logoContainer'>
        <Logo className='cabecalho-logo' />
      </div>
      <div>
        <nav className='cabecalho-navbar'>

          <Link to='/Dashboard' className='nav-item'>Dashboard</Link>
          <Link to='/ConsultarVisitas' className='nav-item'>Visitas</Link>
          <Link to='/ConsultarMotoristas' className='nav-item'>Motoristas</Link>
          <Link to='/Configuracoes' className='nav-item'>Configurações</Link>
          {/*
          <Link
            to="http://192.168.1.9:3001/"
            className='nav-item'
            target="_blank"
            rel="noopener noreferrer"
          >
            Formulario deHeus Motoristas
          </Link>
          */}



        </nav>
      </div>

      <div className='cabecalho-user-container'>
        <span className='cabecalho-username'>Bem Vindo, {username}</span>
        <button onClick={handleLogout} className='cabecalho-logout-button'>
          Sair
        </button>
      </div>
    </header>
  )
}

export default Cabecalho
